import * as React from 'react';
// @ts-expect-error
import type {RouterHistory} from 'react-router';

import {FeatureGateModal} from 'shells/billing/feature-gate/feature-gate-modal';

import {useGetSessionUser} from '../../../core/use-get-session-user';

import {analyticsClient} from '../../../../analytics-client';

type Props = {
    history: RouterHistory;
};

export function LeadLimitUpsellModal(props: Props) {
    const {user, isLoading: userLoading} = useGetSessionUser();
    const [_isLoading, setIsLoading] = React.useState(true);
    const userCanAccessBilling = Boolean(user && user.permissions.canAccessBilling);

    React.useEffect(() => {
        if (!userLoading) {
            setIsLoading(false);
        }
    }, [userLoading]);

    return (
        <FeatureGateModal
            isOpen={true}
            title='Work with more open leads'
            description='Nutshell Foundation is limited to 100 open leads. Upgrade to support your growing pipeline. In addition to more open leads, Growth supports:'
            bullets={[
                'Activity & email reports to measure your outreach',
                'Sales & activity quotas',
                'Customizable lead assignment rules',
            ]}
            onClose={() => {
                props.history.goBack();
            }}
            isAdmin={userCanAccessBilling}
            feature='leadLimit'
            analyticsClient={analyticsClient}
            upgradePlanName={null}
        />
    );
}
